import { useQuery } from '@tanstack/react-query';
import { adminJson } from '@/api/adminJson';

export type SidebarOrderCounts = {
  all: number;
  scheduled: number;
  pending: number;
  accepted: number;
  processing: number;
  item_on_the_way: number;
  delivered: number;
  canceled: number;
  failed: number;
  refunded: number;
  offline_payments: number;
  refund_requested: number;
};

export function useSidebarOrderCounts() {
  return useQuery({
    queryKey: ['sidebar', 'order-counts'],
    queryFn: () =>
      adminJson<{ data: SidebarOrderCounts }>('/admin/json-compat/sidebar-order-counts'),
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}
